module.exports = __webpack_public_path__ + "img/pic_wdyq@3x.e819ea4c.png";